<template>
<div id="gradient" class="icon">
    <img class="w-20 animate-pulse" :src="logo" />
    <ul class="menu font-mono text-xs">

        <li class="spread">
            <router-link class="unit" to="/news"></router-link>
        </li>

        <li class="spread">
            <!-- <router-link class="unit" to="/preview"> spring/summer 2021 preview </router-link> -->
            <router-link class="unit" to="/preview"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/lookbook"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/shop-preview"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/lifestyle"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/about-us"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/mailing-list"></router-link>
        </li>

        <li class="spread">
            <router-link class="unit" to="/contact-us"></router-link>
        </li>

    </ul>
</div>
</template>

<script>
import whiteLogo from '../assets/logo_white.png';
export default {
    name: "LandingMenu",
    data() {
        return {
            logo: whiteLogo
        }
    },
}
</script>

<style lang="scss">
/*     NOTES:
 * [1] Number of list-items you want
 * [2] Size of closed menu "icon"
 * [3] Size of your expanded menu
 * [4] Size of the small units
 * [5] Used to transform the origin of the rotation on the list-itmes to the middle of the menu so they spin out in a centered circle. The same number also offsets position of the list items so they don't sit right on the edge of the actual <ul>, that way there's padding and the menu won't close down if the user moves their cursor a bit too far.
 * [6] Used for the degrees of rotation between each list item, keeping them all evenly spaced. 360 degrees in a circle divided by the number of list items you have
 */
$li: 8;
/* [1] */
$icon-size: 80px;
$icon-width: 66.3359px;
/* [2] */
$menu-size: 600px / 2;
/* [3] */
$unit-size: 150px;
/* [4] */
$menu-position: (($menu-size * 2) - $icon-size) / -2;
$offset: 250px;
/* [5] */
$deg: 360deg / $li;
/* [6] */

/* Styles: */
.icon {
    position: relative;
    cursor: pointer;
    margin: auto;
    height: $icon-width;
    width: $icon-size;
    line-height: $icon-size;
    text-align: center;
    transition: 0.24s 0.2s;
}

.menu {
    position: absolute;
    top: $menu-position;
    left: $menu-position;
    border: $menu-size solid transparent;
    cursor: default;
    border-radius: 50%;
    transform: scale(0);
    transition: transform 1.4s 0.07s;
    z-index: -5;
}

.spread {
    position: absolute;
    top: -($offset);
    left: -($offset);
    transform-origin: $offset $offset;
    transition: all 0.5s 0.1s;
    opacity: 1;
}

.spread:nth-child(2)>a:before {
    font-size: 15px;
    content: 'spring/summer';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: -10px;
    right: 0;
    left: 0;
}

.spread:nth-child(2)>a:after {
    font-size: 15px;
    content: '2021 preview';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 10px;
    right: 0;
    left: 0;
}

.spread:nth-child(3)>a:before {
    font-size: 15px;
    content: 'spring/summer';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: -10px;
    right: 0;
    left: 0;
}

.spread:nth-child(3)>a:after {
    font-size: 15px;
    content: '2021 lookboook';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 10px;
    right: 0;
    left: 0;
}

.spread:nth-child(4)>a:before {
    font-size: 15px;
    content: 'shop';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.spread:nth-child(5)>a:before {
    font-size: 15px;
    content: 'lifestyle';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.spread:nth-child(6)>a:before {
    font-size: 15px;
    content: 'about';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.spread:nth-child(7)>a:before {
    font-size: 15px;
    content: 'mailing list';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.spread:nth-child(8)>a:before {
    font-size: 15px;
    content: 'contact';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.spread:first-child>a:before {
    font-size: 15px;
    content: 'news';
    display: block;
    z-index: -1;
    position: absolute;
    height: 0%;
    top: 0;
    right: 0;
    left: 0;
}

.icon:hover {
    .menu {
        transition: transform 0.4s 0.08s,
            z-index 0s 0.5s;
        transform: scale(1);
        z-index: 5;
    }

    .spread,
    .unit {
        transition: all 0.9s;
    }

    /* Where all the MAGIC happens: */
    @for $m from 1 through $li {
        .spread:nth-child(#{$m}) {
            transition-delay: $m * 0.02s;
            transform: rotate(45 + $deg * $m);

            .unit {
                transition-delay: $m * 0.04s;
                transform: rotate(-$deg * $m + 720 - 45);
            }
        }
    }
}

/* END .icon:hover */

.unit {
    position: absolute;
    background: white;
    text-decoration: none;
    width: $unit-size;
    height: $unit-size;
    line-height: $unit-size;
    border-radius: 50%;
    transition: 0.9s;
    font-size: 75%;
    opacity: 0.5;
}

@keyframes slideyThing {
    from {
        background-position: -700px
    }

    to {
        background-position: 700px
    }
}

#gradient {
    opacity: .8;
    animation: slideyThing 3s infinite linear;
}
</style>
